/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { get } from '../../../services/GenesisApi';
import { UNIT_API } from '../../../constants/Maintenance';
import { IUnit } from '../../../types/Unit.type';

export const getUnits = createAsyncThunk('unit/getUnits', async () => {
  return get(UNIT_API, {})
    .then((response) => {
      return response.data || [];
    })
    .catch((error) => {
      throw error;
    });
});

export interface IUnitState {
  units: IUnit[];
  loading: boolean;
  hasFetched: boolean;
}

export const initialState: IUnitState = {
  units: [],
  loading: false,
  hasFetched: false,
};

const masterDataUnits = createSlice({
  name: 'unitActions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUnits.pending, (state: IUnitState) => {
        state.loading = true;
        state.units = [];
      })
      .addCase(
        getUnits.fulfilled,
        (state: IUnitState, { payload }: PayloadAction<IUnit[]>) => {
          state.units = payload;
          state.loading = false;
          state.hasFetched = true;
        }
      )
      .addCase(getUnits.rejected, (state: IUnitState) => {
        state.loading = false;
        state.hasFetched = true;
      });
  },
});

export const unitActions = masterDataUnits.actions;
export default masterDataUnits.reducer;
